import { UserRole } from "../features/auth/enums/user-roles";

const roleAllowedHistoricalSnapshots = [
    UserRole.Admin,
    UserRole.Operator,
    UserRole.Premium,
];

const roleAllowedOperableLink = [UserRole.Admin, UserRole.Operator];

const roleAllowedStubRules = [UserRole.Admin, UserRole.Operator];

const roleAllowedAccessOtherUserListBuilder = [UserRole.Admin];

const roleAllowedHiddenColumnAccess = [UserRole.Admin, UserRole.Operator];

const roleAllowedLegacyLinksAccess = [UserRole.Admin, UserRole.Operator];

export const hasAccessToHistoricalSnapshots = (role?: UserRole) =>
    role ? roleAllowedHistoricalSnapshots.includes(role) : false;

export const canAccessSourceUrl = (role?: UserRole) =>
    role ? roleAllowedOperableLink.includes(role) : false;

export const canAccessStubRules = (role?: UserRole) =>
    role ? roleAllowedStubRules.includes(role) : false;

export const canAccessOtherUserListBuilder = (role?: UserRole) =>
    role ? roleAllowedAccessOtherUserListBuilder.includes(role) : false;

export const canUpdateHiddenColumnDataset = (role?: UserRole) =>
    role ? roleAllowedHiddenColumnAccess.includes(role) : false;

export const canAccessLegacyLinks = (role?: UserRole) =>
    role ? roleAllowedLegacyLinksAccess.includes(role) : false;
